/**
 * Created by razial on 18.09.2026.
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BP_LAST_CHANCE_RIBBON: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    PASS_PROGRESS_POINT: {
        name: "nostroke"
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassHeader, {
    timer: {
        y: { align: "top", dy: -35 }
    },

    amount: {
        y: { align: "bottom", dy: 35 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.PassProgress, {
    paddingX: 132
});

cleverapps.overrideStyles(cleverapps.styles.PassRewardIcon, {
    text: {
        x: { align: "center", dx: 0 },
        y: { align: "bottom", dy: -10 }
    },

    icon: {
        free: {
            scale: 1.0
        },
        prem: {
            scale: 1.0
        }
    },

    attention: {
        y: { align: "center", dy: -132 }
    }
});
